import { useState, useRef, useEffect } from 'react'
import Boton from './Boton'
import { colors, text, radius, shadow } from '../design/tokens'

/**
 * Botón que despliega un menú de acciones secundarias (patrón "⬇ Descargar ▾" / "⋯ Más ▾").
 * items: [{ label, onClick, destructive? }] — los falsy se filtran (permite condicionales inline).
 * Si no queda ningún item, no se renderiza nada.
 */
export default function BotonMenu({ label, items, variante = 'secondary', sm = false }) {
  const [abierto, setAbierto] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!abierto) return
    const cerrar = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false) }
    document.addEventListener('mousedown', cerrar)
    return () => document.removeEventListener('mousedown', cerrar)
  }, [abierto])

  const visibles = (items || []).filter(Boolean)
  if (!visibles.length) return null

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <Boton variante={variante} sm={sm} onClick={() => setAbierto(a => !a)}>{label} ▾</Boton>
      {abierto && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, marginTop: 4, minWidth: 190, zIndex: 30,
          background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: radius.md,
          boxShadow: shadow.dropdown, padding: 4,
        }}>
          {visibles.map((it, i) => (
            <button key={i} type="button" onClick={() => { setAbierto(false); it.onClick() }}
              style={{
                display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px',
                border: 'none', background: 'transparent', cursor: 'pointer', borderRadius: radius.sm,
                fontSize: text.body, color: it.destructive ? colors.err : colors.text, whiteSpace: 'nowrap',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = colors.bgSoft }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent' }}>
              {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
